function getMaxHeight(elements) {
  return elements.reduce((max, el) => Math.max(max, el.offsetHeight), 0);
}

function createSpacer(height) {
  const spacer = document.createElement('div');
  spacer.className = 'variant-picker--spacer mb-4';
  spacer.style.height = `${height}px`;
  spacer.style.visibility = 'hidden';
  spacer.style.pointerEvents = 'none';
  return spacer;
}

function alignCardsByRow() {
  const cards = Array.from(
    document.querySelectorAll(
      '.tw-product-card:not(.kuResults .tw-product-card)',
    ),
  );
  if (!cards.length) return;

  // Reset card heights and remove old spacers
  cards.forEach((card) => {
    card.style.height = 'auto';
    card.querySelectorAll('.variant-picker--spacer').forEach((s) => s.remove());

    const picker = card.querySelector('.variant-picker__form');
    if (picker) picker.style.minHeight = 'auto';
  });

  // Group cards by row
  const rows = [];
  let currentRowTop = null;
  let currentRow = [];

  cards.forEach((card) => {
    const top = Math.floor(card.getBoundingClientRect().top);
    if (currentRowTop === null || Math.abs(top - currentRowTop) < 5) {
      currentRow.push(card);
      currentRowTop = top;
    } else {
      rows.push(currentRow);
      currentRow = [card];
      currentRowTop = top;
    }
  });
  if (currentRow.length) rows.push(currentRow);

  // Align each row
  rows.forEach((row) => {
    // Cache pickers and Klevu description blocks
    row.forEach((card) => {
      card._picker = card.querySelector('.variant-picker__form');
      card._klevuDesc = card.querySelector('.klevuQuickProductDescBlock');
    });

    // Find tallest picker in the row
    const maxPickerHeight = getMaxHeight(
      row.map((c) => c._picker).filter(Boolean),
    );

    // Find tallest klevuQuickProductDescBlock in the row
    const maxKlevuHeight = getMaxHeight(
      row.map((c) => c._klevuDesc).filter(Boolean),
    );

    const allDescriptionsEmpty = row.every((card) => {
      const desc = card.querySelectorAll('.text-block')?.[1];
      return desc?.textContent?.trim() === '';
    });

    row.forEach((card) => {
      if (allDescriptionsEmpty) {
        const desc = card.querySelectorAll('.text-block')?.[1];
        desc?.remove();
      }

      // Align variant-pickers
      if (card._picker) card._picker.style.minHeight = `${maxPickerHeight}px`;
      else if (maxPickerHeight > 0) {
        const spacer = createSpacer(maxPickerHeight);
        const priceEl =
          card.querySelector('product-price') ||
          card.querySelector('.shopify-block');
        if (priceEl) priceEl.parentNode.insertBefore(spacer, priceEl);
      }

      // Align klevuQuickProductDescBlock heights
      if (card._klevuDesc) {
        const currentHeight = card._klevuDesc.offsetHeight;
        if (maxKlevuHeight > currentHeight) {
          card._klevuDesc.style.height = `${maxKlevuHeight}px`;
        } else {
          card._klevuDesc.style.height = 'auto';
        }
      }
    });

    // Set all cards in row to tallest height
    const maxCardHeight = getMaxHeight(row);
    row.forEach((card) => (card.style.height = `${maxCardHeight}px`));
  });
}

function debounce(fn, delay = 150) {
  let timer;
  return function () {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, arguments), delay);
  };
}

window.alignCardsByRow = alignCardsByRow;

window.addEventListener('load', alignCardsByRow);
window.addEventListener('resize', debounce(alignCardsByRow, 150));
